import _ from 'lodash';
import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRICE_LIST_CUSTOMER,
    method: 'POST',
    data: content,
  });

const read = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.PRICE_LIST_CUSTOMER}/${id}`,
    method: 'GET',
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.PRICE_LIST_CUSTOMER}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.PRICE_LIST_CUSTOMER}/${id}`,
    method: 'DELETE',
  });

const getAll = () =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRICE_LIST_CUSTOMER,
    method: 'GET',
    params: {},
  });

const searchByNameAndCategory = searchText =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRICE_LIST_MASTER,
    method: 'GET',
    params: {
      filter: [
        searchText && {
          type: 'like',
          field: 'description',
          value: `%${searchText}%`,
          where: 'or',
        },
        searchText && {
          type: 'like',
          field: 'code',
          value: `%${searchText}%`,
          where: 'or',
        },
      ].filter(o => o),
    },
    paramsSerializer: params => qs.stringify(params),
  });

const getOptions = (inputValue, callback) => {
  searchByNameAndCategory(inputValue).then(results => {
    callback(
      _.get(results, 'data._embedded.price-list-master', []).map(price => ({
        value: price.id,
        label: `${price.code} - ${price.description}`,
      })),
    );
  });
  // eslint-disable-next-line no-useless-return
  return;
};

const PriceListMasterService = {
  create,
  read,
  update,
  remove,
  getAll,
  getOptions,
};

export default PriceListMasterService;
